module.exports = __webpack_public_path__ + "static/media/dressRoom2.0da61e85.png";